import { Form, Select } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, useContext } from 'react'
import { useGetMachinesQuery } from '../../../store/api/machines-api'
import MachineInterface from '../../../types/api/machine'
import { EndpointQueryParameters, Filters } from '../../../types/strapi/strapi'
import { EditableCellCtx } from '../../editable-cell/editable-cell'

interface MachineProps {
    // Флаг, чтобы выводить только уникальные по бренду станки
    name: NamePath
    unique?: boolean
    noStyle?: boolean
    autoFocus?: boolean
    onBlur?: () => void
    filters?: Filters
    mode?: 'multiple' | 'tags'
    populate?: EndpointQueryParameters['populate']
    disabledMachine?: (machine: MachineInterface) => boolean
}

const Machine: FC<MachineProps> = ({
    unique,
    noStyle,
    autoFocus,
    onBlur,
    filters,
    mode,
    name,
    populate,
    disabledMachine,
}) => {
    const ctx = useContext(EditableCellCtx)
    const { data, isLoading } = useGetMachinesQuery({
        filters,
        populate,
        sort: ['name:asc'],
    })
    let machines = data?.data || []

    const getMachineMainName = (name: string) => {
        return name.split(' ')[0]
    }

    if (unique) {
        machines = machines.reduce((acc: MachineInterface[], cur) => {
            const name = getMachineMainName(cur.name)

            if (!acc.find(x => getMachineMainName(x.name) === name)) {
                acc.push(cur)
            }

            return acc
        }, [])
    }

    const options = machines.map(x => ({
        value: x.documentId,
        label: getMachineMainName(x.name),
        disabled: disabledMachine?.(x),
    }))

    return (
        <Form.Item name={name} noStyle={noStyle}>
            <Select
                style={{ width: '100%' }}
                options={options}
                allowClear
                autoFocus={autoFocus}
                defaultOpen={true}
                onBlur={onBlur ?? ctx.onBlur}
                loading={isLoading}
                mode={mode}
            />
        </Form.Item>
    )
}

export default Machine
